import { FC } from 'react';
import classes from './container.module.css';

export const Container: FC = ({ children }) => (
  <div className={classes.container}>{children}</div>
);
